<section class="ddq-specific-fields">
  <div class="ddq-specific-fields__header">
    <div class="ddq-specific-fields__header-row">
      <div class="ddq-specific-fields__title-wrapper">
        <h2 class="ddq-specific-fields__title">DDQ-Specific Fields</h2>
        <button
          *ngIf="canEdit"
          type="button"
          class="ddq-specific-fields__edit-btn"
          (click)="toggleEdit()"
          [disabled]="isSaving"
          aria-label="Edit DDQ-Specific Fields"
        >
          <span class="material-symbols-outlined" aria-hidden="true">edit</span>
        </button>
      </div>
      <div class="ddq-specific-fields__actions" *ngIf="isEditing">
        <app-az-button
          label="Discard"
          variant="default"
          [showIcon]="false"
          [disabled]="isSaving"
          (click)="discard()"
        />
        <app-az-button
          label="Save Changes"
          variant="primary"
          [showIcon]="false"
          [disabled]="!hasChanges || isSaving || !canSave"
          (click)="saveChanges()"
        />
      </div>
    </div>
    <p class="ddq-specific-fields__subtitle">
      Assignment of the DDQ nominee and management of DDQ (upload and approval)
    </p>
  </div>

  <div class="ddq-specific-fields__fields">
    <div class="ddq-specific-fields__row">
      <div class="ddq-specific-fields__field-with-label">
        <app-form-field
          label="*DDQ Nominee:"
          [value]="currentDdqNominee"
          [disabled]="!isEditing"
          (valueChange)="onDdqNomineeChange($event)"
        />
        <span class="ddq-specific-fields__error" *ngIf="hasEmptyDdqNominee">
          Please enter a DDQ Nominee name
        </span>
      </div>
      <div class="ddq-specific-fields__field-with-label">
        <app-form-field
          label="*Contact Email:"
          [value]="currentContactEmail"
          [disabled]="!isEditing"
          type="email"
          (valueChange)="onContactEmailChange($event)"
        />
        <span class="ddq-specific-fields__error" *ngIf="hasEmptyEmail || hasInvalidEmail">
          {{
            hasEmptyEmail ? 'Please enter a Contact Email' : 'Please enter a valid email address'
          }}
        </span>
      </div>
      <!-- DDQ File section - visible to all BCR roles -->
      <div class="ddq-specific-fields__field-with-label" *ngIf="canSeeDdqFile">
        <span class="ddq-specific-fields__label">DDQ File:</span>

        <!-- Template reutilizable para la lista de documentos -->
        <ng-template #documentsList>
          <div class="ddq-specific-fields__documents-list">
            <a
              *ngFor="let doc of ddqDocuments"
              class="ddq-specific-fields__document-link"
              (click)="downloadDdqDocument(doc)"
            >
              <span class="ddq-specific-fields__document-text">{{ doc.name }}</span>
              <span class="material-symbols-outlined ddq-specific-fields__document-icon"
                >draft</span
              >
            </a>
          </div>
        </ng-template>

        <!-- Documentos arriba del botón cuando shouldShowUploadButton es true -->
        <ng-container *ngIf="ddqDocuments.length > 0 && shouldShowUploadButton">
          <ng-container *ngTemplateOutlet="documentsList"></ng-container>
        </ng-container>

        <!-- Upload button (only PST Member and DDQ Nominee, only when no documents exist or status 7) -->
        <div class="ddq-specific-fields__upload-wrapper" *ngIf="shouldShowUploadButton">
          <app-az-button
            [label]="'Upload'"
            [icon]="'upload'"
            (click)="handleUpload()"
          ></app-az-button>
        </div>

        <!-- Documentos debajo del botón cuando shouldShowUploadButton es false -->
        <ng-container *ngIf="ddqDocuments.length > 0 && !shouldShowUploadButton">
          <ng-container *ngTemplateOutlet="documentsList"></ng-container>
        </ng-container>

        <!-- Approval/Rejection buttons (role-based: PST Member for status 11, Privacy Office for status 12) -->
        <div class="ddq-specific-fields__approval-buttons" *ngIf="shouldShowApprovalButtons">
          <app-az-button
            [label]="'Reject'"
            [variant]="'default'"
            (click)="onRejectDdq()"
          ></app-az-button>
          <app-az-button
            [label]="'Approve'"
            [variant]="'primary'"
            (click)="onApproveDdq()"
          ></app-az-button>
        </div>
      </div>
    </div>
  </div>

  <div class="ddq-specific-fields__tracker">
    <div class="ddq-specific-fields__tracker-header">
      <div class="ddq-specific-fields__title-wrapper">
        <h3 class="ddq-specific-fields__tracker-title">Remediation Action Tracker</h3>
        <button
          *ngIf="canEditRemediationActionsButton"
          type="button"
          class="ddq-specific-fields__edit-btn"
          (click)="toggleRemediationEdit()"
          [disabled]="isSavingRemediationActions"
          aria-label="Edit Remediation Actions"
        >
          <span class="material-symbols-outlined" aria-hidden="true">edit</span>
        </button>
      </div>
      <div class="ddq-specific-fields__actions" *ngIf="isEditingRemediationActions">
        <app-az-button
          label="Discard"
          variant="default"
          [showIcon]="false"
          [disabled]="isSavingRemediationActions"
          (click)="discardRemediationActions()"
        />
        <app-az-button
          label="Save Changes"
          variant="primary"
          [showIcon]="false"
          [disabled]="
            !hasRemediationChanges || hasEmptyRemediationActions || isSavingRemediationActions
          "
          (click)="saveRemediationChanges()"
        />
      </div>
    </div>

    <div
      class="ddq-specific-fields__action"
      *ngFor="let action of remediationActions; let i = index"
    >
      <div class="ddq-specific-fields__action-header">
        <h4 class="ddq-specific-fields__action-label">
          {{ action.isSaved ? 'ACTION ' + getActionNumber(i) : 'NEW ACTION' }}
        </h4>
      </div>

      <div class="ddq-specific-fields__action-row">
        <div class="ddq-specific-fields__field-with-label">
          <app-form-field
            label="*Remediation Action:"
            [value]="action.currentRemediationAction"
            [disabled]="!canEditRemediationActions"
            [isTextArea]="true"
            (valueChange)="onRemediationActionChange(action, $event)"
          />
        </div>
        <div class="ddq-specific-fields__field-with-label">
          <app-az-date-picker
            label="Due Date:"
            [value]="action.currentDueDate"
            [disabled]="!canEditRemediationActions"
            (valueChange)="onDueDateChange(action, $event)"
          />
        </div>
        <div class="ddq-specific-fields__field-with-label">
          <app-az-selector
            label="Status:"
            [options]="statusOptions"
            [selectedValue]="action.currentStatus"
            [disabled]="!canEditRemediationActions || !action.isSaved"
            (selectionChange)="onStatusChange(action, $event)"
          ></app-az-selector>
        </div>
      </div>

      <div class="ddq-specific-fields__action-row">
        <div class="ddq-specific-fields__field-with-label">
          <app-az-date-picker
            label="Date of Completion:"
            [value]="action.currentCompletionDate"
            [disabled]="true"
            (valueChange)="onCompletionDateChange(action, $event)"
          />
        </div>
        <div
          class="ddq-specific-fields__field-with-label ddq-specific-fields__field-with-label--wide"
        >
          <app-form-field
            label="Response:"
            [value]="action.currentComments"
            [disabled]="!canEditRemediationActions"
            [isTextArea]="true"
            (valueChange)="onCommentsChange(action, $event)"
          />
        </div>
      </div>
    </div>

    <div class="ddq-specific-fields__add-action">
      <app-az-button
        label="Add Remediation Action"
        variant="default"
        [showIcon]="false"
        [disabled]="!hasAtLeastOneSavedAction || !canEditRemediationActions"
        (click)="addRemediationAction()"
      />
    </div>
  </div>
</section>

<!-- Warning Modal -->
<app-status-change-modal
  [isOpen]="showWarningModal"
  [initialState]="'custom-confirm'"
  [title]="'Missing Information'"
  [customMessage]="'Please enter a Contact Email before uploading a document.'"
  [customNoButtonLabel]="'Cancel'"
  [customYesButtonLabel]="'OK'"
  (customYes)="closeWarningModal()"
  (customNo)="closeWarningModal()"
  (close)="closeWarningModal()"
/>

<!-- Processing Modal -->
<app-status-change-modal
  [isOpen]="showProcessingModal"
  [initialState]="'processing'"
  [title]="processingModalTitle"
  [processingResultTitle]="processingResultTitle"
  (close)="closeProcessingModal()"
/>

<!-- Confirmation Modal -->
<app-status-change-modal
  [isOpen]="showConfirmModal"
  [initialState]="'custom-confirm'"
  [title]="'DDQ Nominee'"
  [customMessage]="
    'You have selected ' +
    currentDdqNominee +
    ' as a DDQ Nominee. Would you like to send them the Default DDQ File?'
  "
  [customNoButtonLabel]="'No, Modify'"
  [customYesButtonLabel]="'Yes, Send'"
  (customYes)="onConfirmSave()"
  (customNo)="onCancelSave()"
  (close)="closeConfirmModal()"
/>

<!-- Success Modal -->
<app-status-change-modal
  [isOpen]="showSuccessModal"
  [initialState]="'success-with-message'"
  [title]="'DDQ Nominee'"
  [successMessage]="'The Default DDQ File has been successfully sent to ' + currentDdqNominee + '.'"
  [warningMessage]="'The DDQ Nominee might not have access to the BCR Portal. Please add them as a Portal User via '"
  [warningLinkText]="'SailPoint'"
  [warningLinkUrl]="'https://astrazeneca.identitynow.com/ui/d/mysailpoint'"
  (close)="closeSuccessModal()"
/>

<!-- Upload Success Modal -->
<app-status-change-modal
  [isOpen]="showUploadSuccessModal"
  [initialState]="'success-with-message'"
  [title]="'DDQ-Specific Fields'"
  [successMessage]="'The uploaded DDQ File will be sent for approval.'"
  (close)="closeUploadSuccessModal()"
/>

<!-- Error Modal -->
<app-status-change-modal
  [isOpen]="showErrorModal"
  [initialState]="'error'"
  [title]="errorModalTitle"
  [errorMessage]="errorMessage"
  (close)="closeErrorModal()"
/>

<!-- Remediation Completion Confirmation Modal -->
<app-status-change-modal
  [isOpen]="showRemediationCompletionConfirmModal"
  [initialState]="'custom-confirm'"
  [title]="'Remediation Actions Completed'"
  [customMessage]="'All remediation actions have been completed, and PST and PO members will be notified for their review.'"
  [hideButtons]="true"
  (close)="closeRemediationCompletionConfirmModal()"
/>

<!-- Upload Modal -->
<app-az-document-update-modal
  [isOpen]="isUploadModalOpen"
  [documentTypes]="documentTypes"
  [allowedFileTypes]="allowedFileTypes"
  [isUploading]="isUploading"
  [showCommentBox]="true"
  (close)="closeUploadModal()"
  (upload)="onFileUpload($event)"
/>
